import React from "react";

const CancelButton = ({ text, onClick, size }) => {
  return (
    <button
      onClick={onClick}
      className={`px-4 py-1 rounded-full bg-[#e60347] text-white ${
        size === "sm" ? "text-xs" : "text-sm"
      } scale-100 hover:scale-105 transition-all duration-300`}
    >
      {text}
    </button>
  );
};

export default CancelButton;
